export default __webpack_public_path__ + "static/media/Image.a191fab6.jpg";